import React, { useContext, memo } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { ROUTES } from '../constants/constants';

const PrivateRoute = ({ children, ...rest }) => {
  const {
    authState: { isLogged },
  } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLogged ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: ROUTES.LOGIN,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default memo(PrivateRoute);
